import { render, staticRenderFns } from "./ScrollableContentBlock.vue?vue&type=template&id=70098e86&"
import script from "./ScrollableContentBlock.vue?vue&type=script&lang=js&"
export * from "./ScrollableContentBlock.vue?vue&type=script&lang=js&"
import style0 from "./ScrollableContentBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports